module.exports = __webpack_public_path__ + "static/6-2-74da87b27c288cd7d62b91218e7c0f58.jpg";